import React from 'react'
import { Link } from 'react-router-dom'

export default ({ onClick, to, children }) => (
  <p className="control">
    {to && (
      <Link className="button is-white is-large" to={to}>
        <span className="icon is-large">{children}</span>
      </Link>
    )}
    {onClick && (
      <a className="button is-white is-large" onClick={onClick}>
        <span className="icon is-large">{children}</span>
      </a>
    )}
  </p>
)



// WEBPACK FOOTER //
// ./src/components/templates/app/AppNavBarButton.js